import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '@/pages/profile';
import { requireAuth } from '../require-auth';

export const Route = createFileRoute('/profile')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  component: RouteComponent,
});

function RouteComponent() {
  return <ProfilePage />;
}
